<template>
  <v-row justify="center">
    <v-form class="single-form" ref="form" v-model="valid" v-on:submit.prevent="validate">
      <v-dialog
        v-model="dialogQuiz"
        scrollable
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">สร้างคำถาม</v-btn>
        </template>
        <v-card tile>
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              <v-icon left>mdi-file-question-outline</v-icon>สร้างคำถาม
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon dark @click="closeDialog" v-on="on">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">ปิดหน้าต่าง</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col class="pl-0 pt-0" cols="3" :sm="12" :md="3" :lg="3">
                <v-container id="scroll-target" class="pa-0 position">
                  <v-row>
                    <v-toolbar class="px-0">
                      <p class="px-3 mb-0 title">รายการคำถาม</p>
                      <v-spacer></v-spacer>
                      <v-btn
                        :disabled="this.newQuestion == true"
                        class="title"
                        color="primary"
                        :dark="this.newQuestion == true ? false : true"
                        rounded
                        style="float: right"
                        @click="addRowQuestion"
                      >
                        <v-icon left>mdi-plus</v-icon>เพิ่มคำถาม
                      </v-btn>
                    </v-toolbar>
                  </v-row>
                  <v-row justify="center" class="overflow-y-auto fix-height">
                    <v-col class="px-0 pt-0 sticky-top">
                      <v-list-item-group v-model="model" mandatory color="grey draken-1">
                        <div v-for="(qList,index) in arrQuestion" :key="qList._id">
                          <v-divider v-if="qList.divider && qList.id" :key="index"></v-divider>

                          <v-list-item
                            v-if="qList.id"
                            :key="qList.question"
                            @click="arrQuestion[index].id ? editQuestion(qList.id,index+1)  : editDraftForm(index) "
                          >
                            <v-list-item-content>
                              <v-list-item-subtitle>
                                <strong class="font-weight-bold">{{"ข้อที่ "+ (index+1) }}</strong>
                                <span class="subtitle-1 font-weight-lights">
                                  &nbsp;
                                  <v-icon v-if="qList.question == ''">mdi-image</v-icon>
                                  &nbsp;
                                  {{(qList.question == "" ? "รูปภาพ" : qList.question )}}
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    color="error"
                                    icon
                                    @click="removeRowQuestion(qList.id, qList.livestreamID)"
                                    :disabled="arrQuestion.length<=1"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span class="subtitle-1">ลบคำถาม</span>
                              </v-tooltip>
                            </v-list-item-action>
                          </v-list-item>
                        </div>
                      </v-list-item-group>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col class="pl-5" cols="9" :sm="12" :md="9" :lg="9">
                <div class="rowContentmange">
                  <v-alert
                    v-if="this.newQuestion == true"
                    class="headline text-center"
                    :dark="this.edit ? true : false"
                    color="primary"
                  >{{'คำถามใหม่ข้อที่ '+this.edit }}</v-alert>
                  <v-alert
                    v-if="this.newQuestion == false"
                    class="headline text-center"
                    color="grey lighten-2"
                  >{{(this.edit) ? 'คำถามข้อที่ '+this.edit : 'คำถาม'}}</v-alert>
                  <v-row v-if="setbool == false">
                    <v-col cols="12" class="px-10">
                      <v-alert class="mt-6 title" text type="info" border="left">
                        <strong class="font-weight-bold">
                          คำแนะนำ
                          <label class="headExplan">"</label>กดปุ่มเพิ่มคำถาม
                          <label class="headExplan">"</label>
                        </strong> เพื่อเพิ่มคำถามในการถ่ายทอดสด
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row class="px-3">
                    <v-col cols="6" :sm="12" :md="6" :lg="6">
                      <p class="title">โจทย์</p>
                      <v-textarea
                        :disabled="setbool == true ? false : true"
                        rows="10"
                        outlined
                        name="input-7-4"
                        placeholder
                        label="พิมพ์คำถาม"
                        v-model="questionText"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="6" :sm="12" :md="6" :lg="6">
                      <p class="title">รูปภาพ</p>
                      <v-file-input
                        :disabled="setbool == true ? false : true"
                        :rules="fileRules"
                        accept="image/png, image/jpeg, image/bmp"
                        v-model="imageFile"
                        @change="preview"
                        prepend-icon="mdi-camera"
                        :placeholder="imgPreview ? 'เลือกรูปภาพใหม่' : 'เลือกรูปภาพ'"
                        outlined
                        rounded
                        show-size
                      ></v-file-input>
                      <v-card class :color="`grey lighten-2`" elevation="3">
                        <v-img
                          :src="imgPreview == null ? imageReady : imgPreview"
                          :lazy-src="imgPreview"
                          aspect-ratio="1"
                          contain
                          height="200"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-icon
                                v-if="imageReady1"
                                class="mx-auto"
                                elevation="3"
                                size="190"
                              >mdi-card-account-details-outline</v-icon>
                            </v-row>
                          </template>
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row class="px-3">
                    <v-col cols="6" :sm="12" :md="6" :lg="6">
                      <p class="title">
                        คะแนน
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        :disabled="setbool == true ? false : true"
                        type="number"
                        rounded
                        outlined
                        :rules="scoreRules"
                        clearable
                        class="textField"
                        placeholder="คะแนน"
                        v-model="question_score"
                        min="0"
                        @change="checkMinScore"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" :sm="12" :md="6" :lg="6">
                      <p class="title">
                        กำหนดเวลา
                        <span class="red--text">*</span>
                      </p>
                      <v-row>
                        <v-col class="ma-0 pa-0" :sm="6" :md="6" :lg="6">
                          <v-text-field
                            :disabled="setbool == true ? false : true"
                            class="mx-2"
                            rounded
                            outlined
                            v-model="mins"
                            type="number"
                            label="นาที"
                            min="0"
                            max="60"
                            @change="checkMinMins"
                          ></v-text-field>
                        </v-col>
                        <v-col class="ma-0 pa-0" :sm="6" :md="6" :lg="6">
                          <v-text-field
                            :disabled="setbool == true ? false : true"
                            class="mx-2"
                            rounded
                            outlined
                            v-model="secs"
                            type="number"
                            label="วินาที"
                            min="0"
                            max="60"
                            @change="checkMinSec"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" :sm="12" :md="12" :lg="12">
                      <v-divider class="mt-3 mb-0"></v-divider>
                      <v-alert
                        class="headline text-center"
                        :dark="this.newQuestion == true ? true : false"
                        :color=" this.newQuestion == true ? 'primary' :'grey lighten-2'"
                      >ตัวเลือก</v-alert>
                      <v-row>
                        <v-col cols="6" :sm="6" :md="6" :lg="6">
                          <v-card-actions>
                            <v-btn
                              :disabled="setbool == true ? false : true"
                              :color="type=='text' ? 'success' : 'grey'"
                              class="text-center headline mx-auto"
                              width="80%"
                              outlined
                              x-large
                              rounded
                              v-on="on"
                              @click="typeChoice('text')"
                            >
                              <v-icon left large class="mr-4">mdi-alpha-t-box</v-icon>ตัวเลือกรูปแบบข้อความ
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                        <v-col cols="6" :sm="6" :md="6" :lg="6">
                          <v-card-actions>
                            <v-btn
                              :disabled="setbool == true ? false : true"
                              :color="type=='image' ? 'success' : 'grey'"
                              class="text-center headline mx-auto"
                              width="80%"
                              outlined
                              x-large
                              rounded
                              v-on="on"
                              @click="typeChoice('image')"
                            >
                              <v-icon left large class="mr-4">mdi-image</v-icon>ตัวเลือกรูปแบบรูปภาพ
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="type == 'image' || type == 'text'"
                        class="d-flex align-center mb-6 mx-5 title"
                      >
                        <v-col cols="2" lg="2" md="2" sm="2">
                          <p class="title">
                            เลือกคำตอบที่ถูกต้อง
                            <span class="red--text">*</span>
                          </p>
                        </v-col>
                        <v-col cols="8" lg="8" md="8" sm="8">
                          <p class="text-center title">
                            คำตอบ
                            <span class="red--text">*</span>
                          </p>
                        </v-col>
                        <v-col cols="2" lg="2" md="2" sm="2">
                          <p class="text-center title">ลบคำตอบ</p>
                        </v-col>
                      </v-row>

                      <div class="d-flex">
                        <v-col
                          :hidden="type == 'text' ? false : true"
                          cols="12"
                          :sm="12"
                          :md="12"
                          :lg="12"
                        >
                          <div v-for="(row, index) in answer" :key="index">
                            <v-radio-group v-model="answer_correct" :mandatory="false">
                              <v-row
                                class="d-flex align-center my-0 mx-10 lecture-card"
                              >
                                <v-col cols="2" lg="2" md="2" sm="2">
                                  <v-radio
                                    class="align-radio"
                                    :value="index"
                                    :key="index"
                                    :label="(chars) ? `${chars[index]}` : `${index+1}`"
                                  ></v-radio>
                                </v-col>
                                <v-col cols="8" lg="8" md="8" sm="8">
                                  <v-textarea
                                    class="pt-5"
                                    no-resize
                                    rows="5"
                                    outlined
                                    name="input-7-4"
                                    placeholder
                                    label="พิมพ์คำตอบ"
                                    v-model="answer[index].text"
                                    ref="answer"
                                    :value="answer[index].text"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="2" lg="2" md="2" sm="2">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        class="pr5 btn-style"
                                        fab
                                        small
                                        fill
                                        color="error"
                                        @click="removeRow(index)"
                                        :disabled="answer.length<=1"
                                      >
                                        <v-icon>mdi-minus</v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="subtitle-1">ลบคำตอบ</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-radio-group>
                          </div>
                        </v-col>
                        <v-col
                          :hidden="type == 'image' ? false : true"
                          cols="12"
                          :sm="12"
                          :md="12"
                          :lg="12"
                        >
                          <div v-for="(row, index) in answer" :key="index">
                            <v-radio-group v-model="answer_correct" :mandatory="false">
                              <v-row
                                class="d-flex align-center my-0 mx-10 lecture-card"
                              >
                                <v-col cols="2" lg="2" md="2" sm="2">
                                  <v-radio
                                    class="align-radio"
                                    :value="index"
                                    :key="index"
                                    :label="(chars) ? `${chars[index]}` : `${index+1}`"
                                  ></v-radio>
                                </v-col>
                                <v-col cols="8" lg="8" md="8" sm="8">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp"
                                    v-model="imageFileChoice[index]"
                                    @change="previewChoice(index)"
                                    prepend-icon="mdi-camera"
                                    :placeholder="answer[index].image ? 'เลือกรูปภาพใหม่' : 'เลือกรูปภาพ'"
                                    outlined
                                    rounded
                                  ></v-file-input>
                                  <v-card :color="`grey lighten-2`" elevation="3">
                                    <v-img
                                      :src="answer[index].image ? answer[index].image : imageReadyChoice "
                                      :lazy-src="answer[index].image"
                                      aspect-ratio="1"
                                      contain
                                      height="200"
                                    >
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height ma-0"
                                          align="center"
                                          justify="center"
                                        >
                                          <v-icon
                                            v-if="imageReadyChoice"
                                            class="mx-auto"
                                            elevation="3"
                                            size="190"
                                          >mdi-card-account-details-outline</v-icon>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </v-card>
                                </v-col>
                                <v-col cols="2" lg="2" md="2" sm="2">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        class="pr5 btn-style"
                                        fab
                                        small
                                        fill
                                        color="error"
                                        @click="removeRow(index)"
                                        :disabled="answer.length<=1"
                                      >
                                        <v-icon>mdi-minus</v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="subtitle-1">ลบคำตอบ</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-radio-group>
                          </div>
                        </v-col>
                      </div>

                      <v-row justify="center">
                        <v-btn
                          color="primary"
                          class="title"
                          dark
                          x-large
                          rounded
                          v-on="on"
                          @click="addRowAnswer"
                          v-if="type == 'image' || type == 'text'"
                        >
                          <v-icon left>mdi-plus</v-icon>เพิ่มตัวเลือก
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3"></v-divider>
                  <v-card-actions class="my-3">
                    <v-spacer></v-spacer>
                    <v-btn
                      width="15%"
                      color="grey darken-1"
                      class="title"
                      x-large
                      dark
                      rounded
                      outlined
                      @click="closeDialog"
                    >ยกเลิก</v-btn>
                    <v-btn
                      width="15%"
                      class="title"
                      color="primary"
                      :disabled="!validationForm()"
                      @click="validate"
                      x-large
                      rounded
                    >บันทึก</v-btn>
                  </v-card-actions>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-dialog v-model="dialogSwipe" persistent max-width="450">
            <v-card>
              <v-card-title class="headline">ยืนยันการเลือกรูปแบบตัวเลือก</v-card-title>
              <v-card-text class="subtitle-1">
                รูปแบบของตัวเลือกสามารถกำหนดได้เพียง 1 รูปแบบเท่านั้น
                <br />หากกดปุ่มยืนยันแล้วจะเปลี่ยนรูปแบบตัวเลือกทันที
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="grey darken-1"
                  class="px-9 ma-2 title"
                  large
                  dark
                  rounded
                  outlined
                  @click="cancelSwipe"
                >ยกเลิก</v-btn>
                <v-btn
                  color="error darken-1"
                  class="px-10 ma-2 title"
                  large
                  dark
                  rounded
                  @click="resetQuestion(tempType)"
                >ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" persistent max-width="450">
            <v-card>
              <v-card-title class="headline">คุณต้องการลบคำถามนี้หรือไม่</v-card-title>
              <v-card-text>เมื่อลบคำถามนี้แล้ว จะไม่สามารถนำข้อมูลกลับมาได้อีก</v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="grey darken-1"
                  class="px-9 ma-2 title"
                  large
                  dark
                  rounded
                  outlined
                  @click="dialogDelete = false"
                >ยกเลิก</v-btn>
                <v-btn
                  class="px-10 ma-2 title"
                  large
                  color="error darken-1"
                  dark
                  rounded
                  @click="deleteQuiz(questionID, streamID)"
                >ยืนยัน</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDeleteSuccess" max-width="450">
            <v-card>
              <v-card-title class="headline">ลบคำถามเรียบร้อย</v-card-title>

              <v-card-text>คำถามถูกลบออกจากระบบเรียบร้อยแล้ว</v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="dialogDeleteSuccess = false">เสร็จสิ้น</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogUpdateSuccess" max-width="450">
            <v-card>
              <v-card-title class="headline">บันทึกคำถามเรียบร้อย</v-card-title>

              <v-card-text>คำถามได้ถูกบันทึกในระบบเรียบร้อยแล้ว</v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="dialogUpdateSuccess = false">เสร็จสิ้น</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>
<script>
import { uploadImage } from "@/service/upload/upload";
import { insertChoice, updateChoice } from "@/service/course/exam.js";
import {
  getListQuiz,
  insertQuiz,
  updateQuiz,
  deleteQuiz
} from "@/service/course/quiz.js";
export default {
  data() {
    return {
      dialogQuiz: false,
      dialogSwipe: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogUpdateSuccess: false,

      model: null,
      mins: 0,
      secs: 0,
      question_score: 0,
      imgURL: "",
      imgPreview: "",
      imgPreviewChoice: [{ preview: "" }],
      imageFile: null,
      imageFileChoice: [],
      imageReady: false,
      imageReadyChoice: false,
      type: "",
      edit: null,
      choiceCheck: "",
      choiceText: "",
      questionText: "",
      arrQuestion: [],
      answer: [
        {
          text: "",
          image: ""
        }
      ],
      answer_correct: 0,
      indexQuestion: 0,
      idLiveStream: "5ec68f554b95f34a99091ce5",
      params: {},
      questionID: "",
      streamID: "",
      editId: "",
      valid: false,
      setbool: false,
      newQuestion: false,
      tempType: "",
      editForm: [],
      scoreRules: [v => !!v || "Score is required"],
      minuteRules: [v => !!v || "Minute is required"],
      secondRules: [v => !!v || "Second is required"]
    };
  },
  mounted() {
    this.initialize();
    this.scrollToEnd();
  },
  // updated() {
  //   this.scrollToEnd();
  // },

  methods: {
    initialize() {
      this.getQuestionList();
    },
    scrollToEnd() {
      var container = document.querySelector(".fix-height");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    typeChoice(type) {
      this.tempType = type;
      this.dialogSwipe = true;
    },
    closeDialog() {
      this.dialogQuiz = false;
      this.newQuestion = false;
      this.edit = null;
      console.log(this.newQuestion);

      this.setbool = false;
      this.questionText = "";
      this.imgPreview = "";
      this.imgPreviewChoice = [{ preview: "" }];
      this.imageFileChoice = [];
      this.imageReady = false;
      this.imageReadyChoice = false;
      this.question_score = 0;
      this.mins = 0;
      this.secs = 0;
      this.answer = [
        {
          text: "",
          image: ""
        }
      ];
      this.editId = "";
      this.type = "text";
      this.$refs.form.resetValidation();
    },
    resetQuestion(type) {
      switch (type) {
        case "text":
          this.type = "";
          this.type = "text";
          this.answer = [
            {
              text: "",
              image: ""
            }
          ];
          this.dialogSwipe = false;
          break;
        case "image":
          this.type = "";
          this.type = "image";
          this.answer = [
            {
              text: "",
              image: ""
            }
          ];
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    cancelSwipe() {
      this.type;
      this.dialogSwipe = false;
    },
    choiceCheckAnswer(choice) {
      this.choiceCheck = choice;
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    addRowAnswer: function() {
      if (this.type == "text") {
        this.answer.push({ text: "" });
      } else {
        this.answer.push({ image: "" });
      }
      console.log(this.answer);
    },
    removeRow: function(index) {
      console.log("row" + index, this.answer.length);
      console.log(this.answer);
      console.log(this.answer_correct, index);
      // this.rows.$remove(index);
      if (this.answer.length > 1) {
        if (this.answer_correct === index) {
          this.answer_correct = 0;
        } else if (this.answer_correct > index) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(index, 1);
      }
    },

    addRowQuestion: function() {
      this.scrollToEnd();
      this.arrQuestion.push({
        question: "",
        imageFile: null,
        score: 0,
        mins: 0,
        secs: 0,
        answer: [
          {
            text: "",
            image: ""
          }
        ],
        id: "",
        divider: true
      });
      this.edit = this.arrQuestion.length;
      this.setbool = true;
      this.questionText = "";
      this.imgPreview = "";
      this.imgPreviewChoice = [{ preview: "" }];
      this.imageFileChoice = [];
      this.imageReady = false;
      this.imageReadyChoice = false;
      this.question_score = 0;
      this.mins = 0;
      this.secs = 0;
      this.answer = [
        {
          text: "",
          image: ""
        }
      ];
      this.editId = "";
      this.newQuestion = true;
      this.type = "text";
      this.$refs.form.resetValidation();
      console.log(this.arrQuestion);
    },
    removeRowQuestion: function(questionID, streamID) {
      this.dialogDelete = true;
      this.questionID = questionID;
      this.streamID = streamID;
      console.log(this.questionID, " :::: ", this.streamID);
    },
    async deleteQuiz(questionID, streamID) {
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      await deleteQuiz({
        idlivestream: streamID,
        idquiz: questionID
      });
      this.arrQuestion = [];
      this.getQuestionList();
    },
    checkMinMins() {
      if (this.mins < 0) this.mins = 0;
    },
    checkMinSecs() {
      if (this.secs < 0) this.secs = 0;
      if (this.secs > 60) this.secs = 60;
    },
    // async checkMoveQuestion() {
    //   let arrayQuestionId = [];

    //   this.arrQuestion.map(question =>
    //     question.children.length > 0
    //       ? (arrayQuestionId.push(question._id),
    //         question.children.map(child => arrayQuestionId.push(child._id)))
    //       : arrayQuestionId.push(question._id)
    //   );

    //   console.log("Swarp", arrayQuestionId.length);
    //   this.selected_exam = [];
    //   this.allSelected = false;
    //   await this.reorderQuestion(this.examId, arrayQuestionId);
    //   this.selected_exam = [];
    //   this.allSelected = false;
    //   this.dialog = false;
    // },
    async uploadImg(image) {
      let status = await uploadImage("question", image);
      return status;
    },
    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
        console.log("UPLOADED IMAGE:", this.imgPreview);
      } else {
        this.imageReady = false;
      }
    },
    async previewChoice(index) {
      // console.log(index)
      if (this.imageFileChoice[index] != null) {
        this.imgURL = await this.uploadImg(this.imageFileChoice[index]);
        this.answer[index].text = "";
        this.answer[index].image = this.imgURL;

        // this.imgPreviewChoice = this.imgURL;
        this.imageReadyChoice = true;
        // this.imageFileChoice = "";
        console.log("UPLOADED IMAGE:", this.answer);
      } else {
        this.imageReadyChoice = false;
      }
    },
    editQuestion(id, index) {
      console.log(id);
      this.setbool = true;
      this.newQuestion = false;
      this.edit = index;
      this.editId = id;
      let tempMin = null;
      let tempSec = null;
      if (this.mins >= 0 || this.secs >= 0) {
        this.$refs.form.resetValidation();
      }
      for (var i = 0; i < this.arrQuestion.length; i++) {
        if (id == this.arrQuestion[i].id) {
          tempMin = this.arrQuestion[i].time / 1000 / 60;
          tempSec = (this.arrQuestion[i].time / 1000) % 60;
          this.mins = parseInt(tempMin);
          this.secs = tempSec;
          this.questionText = this.arrQuestion[i].question;
          this.imgPreview = this.arrQuestion[i].imageQuestion;
          this.imageReady = true;
          this.question_score = this.arrQuestion[i].score;
          this.answer = this.arrQuestion[i].choices;
          this.answer_correct = this.arrQuestion[i].correctAnswer[0];
          this.imageReadyChoice = true;
          this.choiceCheck = this.arrQuestion[i].correctAnswer[0];

          this.answer.forEach((value, index) => {
            if (this.answer_correct === value._id) {
              this.answer_correct = index;
              console.log(this.answer_correct);
            }
          });

          if (
            this.arrQuestion[i].choices[0].text == "" ||
            this.arrQuestion[i].choices[0].text == null
          ) {
            this.type = "image";
          }
          if (
            this.arrQuestion[i].choices[0].image == "" ||
            this.arrQuestion[i].choices[0].image == null
          ) {
            this.type = "text";
          }
        }
      }
      console.log("get edit type : ", this.type);
      console.log(this.answer);
      console.log(this.imgPreview);
      console.log(this.answer_correct);
    },
    editDraftForm(index) {
      console.log(index);
      // this.mins = ;
      // this.secs = ;
      // this.questionText = ;
      // this.imgPreview = ;
      // this.imageReady = true;
      // this.question_score = ;
      // this.answer = ;
      // this.imageReadyChoice = true;
      // this.choiceCheck = ;
      this.questionText = "";
      this.imgPreview = "";
      this.imgPreviewChoice = [{ preview: "" }];
      this.imageFileChoice = [];
      this.imageReady = false;
      this.imageReadyChoice = false;
      this.question_score = 0;
      this.mins = 0;
      this.secs = 0;
      this.answer = [
        {
          text: "",
          image: ""
        }
      ];
      this.$refs.form.resetValidation();
    },
    validationForm() {
      let bool = true;

      this.answer.forEach(item => {
        if (item.length < 1 || (item.text == "" && item.image == "")) {
          bool = false;
        }
      });
      if (this.mins >= 0 || this.secs >= 0) {
        this.valid = true;
      }
      return this.valid && bool;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        console.log(this.answer);
        let arrChoiceId = [];
        let choiceCorrect = [];
        if (this.mins >= 0 || this.secs >= 0) {
          this.$refs.form.resetValidation();
        }
        for (var i = 0; i < this.answer.length; i++) {
          if (this.answer[i]._id) {
            let result = await updateChoice({
              id: this.answer[i]._id,
              text: this.answer[i].text,
              image: this.answer[i].image
            });
            await arrChoiceId.push(result._id);
          } else {
            let result = await insertChoice({
              text: this.answer[i].text,
              image: this.answer[i].image
            });
            await arrChoiceId.push(result._id);
          }
        }

        if (arrChoiceId) {
          arrChoiceId.forEach((value, index) => {
            if (this.answer_correct === index) {
              choiceCorrect.push(value);
              console.log("คำตอบถูก : ", choiceCorrect);
            }
          });
        }
        let milliSec = this.secs * 1000;
        let milliMin = this.mins * 60000;
        let timeLimited = milliMin + milliSec;
        console.log(timeLimited);

        let question = {
          idlivestream: this.idLiveStream,
          question: this.questionText,
          imageQuestion: this.imgPreview,
          choices: arrChoiceId,
          correct: choiceCorrect,
          score: this.question_score,
          time: timeLimited
        };
        console.log(question);
        if (this.editId) {
          console.log(this.imgPreview);
          let resultQuestion = await updateQuiz({
            idquiz: this.editId,
            ...question
          });
          console.log(resultQuestion);
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = "";
            this.type = "";
            this.questionText = "";
            this.imgPreview = "";
            this.imgPreviewChoice = [{ preview: "" }];
            this.imageFileChoice = [];
            this.imageReady = false;
            this.imageReadyChoice = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [
              {
                text: "",
                image: ""
              }
            ];
            this.setbool = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        } else {
          let resultQuestion = await insertQuiz(question);
          console.log(resultQuestion);
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = "";
            this.type = "";
            this.questionText = "";
            this.imgPreview = "";
            this.imgPreviewChoice = [{ preview: "" }];
            this.imageFileChoice = [];
            this.imageReady = false;
            this.imageReadyChoice = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [
              {
                text: "",
                image: ""
              }
            ];
            this.setbool = false;
            this.newQuestion = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        }
      } else {
        console.log("not pass");
      }
    },

    async getQuestionList() {
      console.log(this.params);
      this.params = {
        idlivestream: this.idLiveStream
      };
      let result = await getListQuiz({
        idlivestream: this.idLiveStream
      });
      console.log("Quiz list : ", result);
      this.arrQuestion = [];
      result.data.forEach(quiz => {
        this.arrQuestion.push({
          id: quiz._id,
          livestreamID: this.idLiveStream,
          question: quiz.question,
          choices: quiz.choices,
          correctAnswer: quiz.correct,
          imageQuestion: quiz.imageQuestion,
          score: quiz.score,
          time: quiz.time,
          divider: true
        });
      });
      console.log("Quizs list : ", this.arrQuestion);
    }
  } //methods
};
</script>
<style scoped>
.align-radio {
  text-align: center;
  display: block;
}
.btn-style {
  margin-left: 80px;
  margin-right: 80px;
}
.v-text-field__details {
  display: none;
}
.fix-height {
  height: 85vh;
  overflow: scroll;
}
.position {
  position: fixed;
  width: 24%;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  background-color: #fafafa !important;
  border-color: #fafafa !important;
  transition: transform 0.3s ease-in-out;
}
.q-card {
  background-color: #fafafa !important;
}
.q-card:hover {
  background-color: #e0e0e0 !important;
  box-shadow: none;
}
.q-card-edit {
  background-color: #e0e0e0 !important;
}
.vCard {
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
  border-color: #4caf50 !important;
  box-shadow: 0 3px 10px 0 #d6f5d7;
}
/* .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 15px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
} */
.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 16px;
}
.footer {
  position: fixed;
  width: 25%;
  left: 1vh;
  bottom: 3vh;
  text-align: center;
}
.rowContentmange {
  border-style: solid;
  border-radius: 4px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.fix-mx {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
@media only screen and (max-width: 1024px) {
  .subtitle-1 {
    font-size: 0.8rem !important;
  }
  .headline,
  .title {
    font-size: 1rem !important;
  }
  .fix-height {
    height: 80vh;
  }
  .btn-style {
    margin-left: 40px;
    margin-right: 40px;
  }
}
@media only screen and (max-width: 768px) {
  .headline,
  .title {
    font-size: 1rem !important;
  }
  .footer {
    position: relative;
    width: 100%;
    left: 0vh;
    bottom: 0vh;
    text-align: center;
  }
  .sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 16px;
  }
  .fix-height {
    height: 50vh;
  }
  .position {
    position: relative;
    width: 100%;
  }
  .fix-mx {
    margin-left: 0;
    margin-right: 0;
  }
  .fix-con-mx {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
